module.exports = __webpack_public_path__ + "static/media/nav-icon4.4d8a171d.svg";